import { Backdrop, CircularProgress } from '@mui/material'

import PageWrapper from '/components/page-wrapper'

const Loading = () => {

  return (
    <PageWrapper title="Loading...">
      <div className="flex h-screen">
        <div className="m-auto flex flex-row gap-10">
          <Backdrop open={true} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
            <CircularProgress className='mr-20'/> Initialising...
          </Backdrop>
        </div>
      </div>
    </PageWrapper>
  )
}

export default Loading